<template>
  <div class="motivate">
    <div class="motivate_form">
      <el-form
        :inline="true"
        :model="motivateForm"
        ref="motivateForm"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="所属师傅" prop="userIds">
          <el-select
            multiple
            filterable
            v-model="motivateForm.userIds"
            placeholder="请选择所属师傅"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyIds">
          <el-select
            multiple
            filterable
            v-model="motivateForm.companyIds"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="String(item.companyId)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="brandIds">
          <el-select
            multiple
            filterable
            v-model="motivateForm.brandIds"
            placeholder="请选择"
          >
            <el-option
              v-for="item in deviceBrandDrownList"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="motivateForm.remarks"
            placeholder="请输入备注"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData(true)"
            >查询</el-button
          >
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="motivate_table">
      <div class="table_btn">
        <div>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="showDialog('add', null)"
            v-show="
              authorization(
                '/home-admin/routineManage/fee-group-manage/management-fee/add'
              )
            "
            >新增</el-button
          >
        </div>
        <div>
          <el-button
            type="primary"
            size="small"
            @click="batchAdd"
            v-show="
              authorization(
                '/home-admin/routineManage/fee-group-manage/management-fee/add'
              )
            "
            style="float: right; margin-top: 10px; margin-bottom: 10px"
            >批量添加所有群组师傅</el-button
          >
        </div>
        <div>
          <el-button
            type="success"
            size="small"
            @click="copy"
            style="float: right; margin-top: 10px; margin-bottom: 10px"
            >复制</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        height="80%"
        size="small"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="userIdStr" label="所属师傅"></el-table-column>
        <el-table-column prop="companyIdStr" label="所属公司"></el-table-column>
        <el-table-column prop="brandIdStr" label="品牌"></el-table-column>
        <el-table-column
          prop="managementFee"
          label="管理费用"
        ></el-table-column>
        <el-table-column
          prop="remarks"
          show-overflow-tooltip
          label="备注"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          width="130"
          label="创建时间"
        ></el-table-column>
        <el-table-column prop="createdByStr" label="创建人"></el-table-column>
        <el-table-column
          prop="updateTime"
          width="130"
          label="修改时间"
        ></el-table-column>
        <el-table-column prop="updatedByStr" label="修改人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top-end"
              v-show="
                authorization(
                  '/home-admin/routineManage/fee-group-manage/management-fee/edit'
                )
              "
            >
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                size="mini"
                style="margin-right: 5px; margin-left: 5px"
                @click="showDialog('edit', scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top-end"
              v-show="
                authorization(
                  '/home-admin/routineManage/fee-group-manage/management-fee/del'
                )
              "
            >
              <el-popconfirm
                title="确认删除吗？"
                @confirm="deleteData(scope.row)"
              >
                <!--  -->
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          padding-top: 20px;
          height: 40px;
          background-color: #fff;
          width: 100%;
          border-radius: 0 0 8px 8px;
          text-align: right;
        "
      >
        <el-pagination
          background
          :page-sizes="sizes"
          layout="total,sizes,prev,pager,next"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="sizeChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogFormEdit"
      width="700px"
      :close-on-click-modal="false"
      @closed="dialogClose"
    >
      <el-form
        :model="motivateDialogForm"
        ref="userArray"
        :rules="DialogRules"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="所属师傅:" prop="userId">
          <el-select
            filterable
            clearable
            style="width: 100%"
            v-model="motivateDialogForm.userId"
            placeholder="请选择所属师傅"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司:" prop="companyId">
          <el-select
            filterable
            clearable
            style="width: 100%"
            v-model="motivateDialogForm.companyId"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="String(item.companyId)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌:" prop="brandId">
          <el-select
            clearable
            filterable
            style="width: 100%"
            v-model="motivateDialogForm.brandId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in deviceBrandDrownList"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理费用:" prop="managementFee">
          <el-input
            v-model="motivateDialogForm.managementFee"
            placeholder="请输入管理费用"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input
            type="textarea"
            maxlength="500"
            placeholder="请输入备注"
            v-model="motivateDialogForm.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose(false)" size="small">取 消</el-button>
        <el-button type="primary" @click="submit(false)" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量新增 -->
    <el-dialog
      title="批量新增"
      :visible.sync="dialogFormEditBatch"
      width="700px"
      :close-on-click-modal="false"
      @closed="dialogClose(true)"
    >
      <el-form
        :model="motivateDialogFormBatch"
        ref="batchAddForm"
        :rules="DialogRules"
        label-width="160px"
        size="small"
        style="width: 600px"
      >
        <el-form-item label="所属师傅:" prop="userId">
          <el-select
            filterable
            clearable
            style="width: 100%"
            multiple
            v-model="motivateDialogFormBatch.userId"
            placeholder="请选择所属师傅"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司:" prop="companyId">
          <el-select
            filterable
            clearable
            style="width: 100%"
            v-model="motivateDialogFormBatch.companyId"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="String(item.companyId)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌:" prop="brandId">
          <el-select
            clearable
            filterable
            style="width: 100%"
            v-model="motivateDialogFormBatch.brandId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in deviceBrandDrownList"
              :key="item.id"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="管理费用:" prop="managementFee">
          <el-input
            v-model="motivateDialogFormBatch.managementFee"
            placeholder="请输入管理费用"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remarks">
          <el-input
            type="textarea"
            maxlength="500"
            placeholder="请输入备注"
            v-model="motivateDialogFormBatch.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose(true)" size="small">取 消</el-button>
        <el-button type="primary" @click="submit(true)" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { authorization } from "../../../authorization/authorization";
import { validateNumber } from "@/utils/index";
export default {
  name: "Motivate",
  data() {
    return {
      motivateForm: {
        companyIds: [],
        brandIds: [],
        userIds: [],
        remarks: "",
      },
      tableData: [],
      tableSelectData: [],
      total: 0,
      sizes: [10, 15, 20, 50],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      dialogFormEdit: false,
      dialogFormEditBatch: false,
      motivateDialogForm: {
        userId: "",
        brandId: "",
        companyId: "",
        managementFee: "",
        remarks: "",
      },
      motivateDialogFormBatch: {
        userIds: [],
        userId:[],
        brandId: "",
        companyId: "",
        managementFee: "",
        remarks: "",
      },
      DialogRules: {
        userId: [
          { required: true, message: "请选择所属师傅", trigger: "change" },
        ],
        brandId: [{ required: true, message: "请选择品牌", trigger: "change" }],
        companyId: [
          { required: true, message: "请选择所属公司", trigger: "change" },
        ],
        managementFee: [
          { required: true, message: "请输入管理费用", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
      },
      companyDrownList: this.$store.state.company,
      deviceBrandDrownList: this.$store.state.brand,
      isAdd: true,
      userList: [], //师傅列表
      id: "",
    };
  },
  created() {
    this.getGroupUserList();
    this.getData(true);
  },
  methods: {
    authorization,
    handleSelectionChange(val) {
      this.tableSelectData = val;
    },
    batchAdd() {
      this.dialogFormEditBatch = true;
      this.motivateDialogFormBatch.userId = this.userList.map((item) => item.id);
    },
    copy() {
      if (this.tableSelectData.length == 0) {
        this.$message.warning("请选择要复制的群组数据");
        return;
      } else if (this.tableSelectData.length > 1) {
        this.$message.warning("只能选择一条数据进行复制");
        return;
      } else {
        this.motivateDialogForm.userId = this.tableSelectData[0].userId;
        this.motivateDialogForm.brandId = this.tableSelectData[0].brandId;
        this.motivateDialogForm.companyId = this.tableSelectData[0].companyId;
        this.motivateDialogForm.managementFee =
          this.tableSelectData[0].managementFee;
        this.motivateDialogForm.remarks = this.tableSelectData[0].remarks;
        this.isAdd = true;
        this.dialogFormEdit = true;
      }
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getData(false);
    },
    sizeChange(val) {
      this.page.pageSize = val;
      this.getData(false);
    },
    showDialog(type, data) {
      this.isAdd = type === "add" ? true : false;
      this.dialogFormEdit = true;
      if (data) {
        this.motivateDialogForm.userId = data.userId;
        this.motivateDialogForm.brandId = data.brandId;
        this.motivateDialogForm.companyId = data.companyId;
        this.motivateDialogForm.managementFee = data.managementFee;
        this.motivateDialogForm.remarks = data.remarks;
        this.id = data.id;
      }
    },
    // 获取当前管理组下的所属师傅列表
    getGroupUserList() {
      this.axios({
        method: "get",
        url: `/management-fee-detail/listByFeeGroupID/${this.$route.query.id}`,
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.userList = res.data.data.map((item) => {
            return {
              id: item.id,
              userName: item.userName,
            };
          });
        }
      });
    },
    getData(flag) {
      if (flag) {
        this.page.pageNum = 1;
        this.page.pageSize = 10;
      }
      this.axios({
        method: "post",
        url: "/management-fee-detail/list",
        data: {
          page: this.page.pageNum,
          size: this.page.pageSize,
          queryInfoParams: {
            ...this.motivateForm,
            groupId: this.$route.query.id,
          },
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        } else {
          this.$message.error(res.data.msg || res.data.message);
        }
      });
    },
    dialogClose(batch) {
      if (batch) {
        this.dialogFormEditBatch = false;
        setTimeout(() => {
          this.$refs.batchAddForm.resetFields();
        }, 150);
      } else {
        this.dialogFormEdit = false;
        this.$refs.userArray.resetFields();
        this.motivateDialogForm = {
          userId: "",
          brandId: "",
          companyId: "",
          managementFee: "",
          remarks: "",
        };
        this.id = "";
      }
    },
    submit(batch) {
      if (batch) {
        this.$refs.batchAddForm.validate((valid) => {
          if (valid) {
            this.axios({
              method: "post",
              url: "/management-fee-detail/add",
              data: {
                ...this.motivateDialogFormBatch,
                userIds: this.motivateDialogFormBatch.userId,
                userId:'',
                groupId: this.$route.query.id,
              },
            }).then((res) => {
              if (res.data.code === 200) {
                this.$message.success("新增成功！");
                this.dialogClose(true);
                this.getData(true);
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            return false;
          }
        });
      } else {
        this.$refs.userArray.validate((valid) => {
          if (valid) {
            if (this.isAdd) {
              this.add();
            } else {
              this.edit();
            }
          } else {
            return false;
          }
        });
      }
    },
    add() {
      this.axios({
        method: "post",
        url: "/management-fee-detail/add",
        data: {
          ...this.motivateDialogForm,
          groupId: this.$route.query.id,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("新增成功！");
          this.dialogClose();
          this.getData(true);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    edit() {
      this.axios({
        method: "post",
        url: `/management-fee-detail/edit/${this.id}`,
        data: {
          ...this.motivateDialogForm,
          groupId: this.$route.query.id,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("编辑成功！");
          this.dialogClose();
          this.getData(false);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    deleteData(data) {
      this.axios({
        method: "DELETE",
        url: `/management-fee-detail/del/${data.id}`,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("删除成功！");
          this.getData(false);
        } else {
          this.$message.error(res.data.msg || res.data.message);
        }
      });
    },
    reset() {
      this.$refs.motivateForm.resetFields();
      this.getData(true);
    },
  },
};
</script>

<style scoped>
.motivate {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.motivate_form {
  width: 100%;
  overflow: hidden;
}

.motivate_table {
  height: 100%;
  padding: 20px 5px 0 20px;
  background-color: #fff;
  border-radius: 8px;
}

.table_btn {
  display: flex;
  align-items: center;
}

.table_btn > div {
  margin-right: 20px;
}
</style>
